import { stateChangeOnlyActionCreator } from '../../store/actionCreators';
import {
  SET_ENTITY_DIALOG_ASK_CONFIRMATION,
  SET_ENTITY_DIALOG_COMPONENT_NAME,
  SET_ENTITY_DIALOG_DATA_LOADING_STATUS,
  SET_ENTITY_DIALOG_DATA_SUCCESS_STATUS,
  SET_ENTITY_DIALOG_TITLE,
  SET_ENTITY_DIALOG_TITLE_APPENDER,
  SET_ENTITY_DIALOG_VISIBILiTY_STATUS,
} from './actionTypes';

export const setEntityDialogLoadingStatusAction = stateChangeOnlyActionCreator(SET_ENTITY_DIALOG_DATA_LOADING_STATUS);
export const setEntityDialogDataLoadedStatusAction = stateChangeOnlyActionCreator(
  SET_ENTITY_DIALOG_DATA_SUCCESS_STATUS,
);
export const setEntityDialogVisibilityStatusAction = stateChangeOnlyActionCreator(SET_ENTITY_DIALOG_VISIBILiTY_STATUS);
export const setEntityDialogComponentNameAction = stateChangeOnlyActionCreator(SET_ENTITY_DIALOG_COMPONENT_NAME);
export const setEntityDialogTitleAction = stateChangeOnlyActionCreator(SET_ENTITY_DIALOG_TITLE);
export const setEntityDialogTitleAppenderAction = stateChangeOnlyActionCreator(SET_ENTITY_DIALOG_TITLE_APPENDER);
export const setEntityDialogAskConfirmationAction = stateChangeOnlyActionCreator(SET_ENTITY_DIALOG_ASK_CONFIRMATION);
